export default "__VITE_ASSET__E_ZatVP$__"